import { render } from "./ListMonitaryNotesView.vue?vue&type=template&id=566502fd&scoped=true&ts=true"
import script from "./ListMonitaryNotesView.vue?vue&type=script&lang=ts"
export * from "./ListMonitaryNotesView.vue?vue&type=script&lang=ts"

import "./ListMonitaryNotesView.vue?vue&type=style&index=0&id=566502fd&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566502fd"]])

export default __exports__